import React from 'react';
import { Card, Col, Row } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBolt,
  faBan,
  faGavel,
  faKey,
  faShieldAlt,
} from '@fortawesome/free-solid-svg-icons';
import PageHeader from '../../components/PageHeader';
import { Routes } from '../../routes';
import { useAuth } from '../../context/AuthContext';

const tiles = [
  {
    title: 'Decision',
    text: 'Evaluate events against blocklist and velocity rules.',
    icon: faGavel,
    path: Routes.Decide.path,
  },
  {
    title: 'Rules',
    text: 'Manage COUNT and SUM aggregation rules.',
    icon: faBolt,
    path: Routes.Rules.path,
  },
  {
    title: 'Blocklist',
    text: 'Deny known-bad identifiers before rule evaluation.',
    icon: faBan,
    path: Routes.Blocklist.path,
  },
  {
    title: 'Tokens',
    text: 'Tokenize and detokenize sensitive values.',
    icon: faKey,
    path: Routes.Tokens.path,
  },
  {
    title: 'Account',
    text: 'Rotate or revoke client secrets.',
    icon: faShieldAlt,
    path: Routes.Account.path,
  },
];

export default function Dashboard() {
  const { tenantId } = useAuth();

  return (
    <>
      <PageHeader
        title="Dashboard"
        subtitle="Rules-based risk engine for high-volume event streams."
      />
      <Row className="mb-4">
        <Col>
          <Card border="light" className="shadow-sm">
            <Card.Body>
              <h6 className="text-uppercase text-gray mb-2">Tenant</h6>
              <code>{tenantId}</code>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        {tiles.map((tile) => (
          <Col xs={12} md={6} xl={4} className="mb-4" key={tile.title}>
            <Card as={Link} to={tile.path} border="light" className="shadow-sm h-100 text-decoration-none">
              <Card.Body>
                <div className="icon icon-shape icon-md icon-primary rounded me-3 mb-3">
                  <FontAwesomeIcon icon={tile.icon} />
                </div>
                <h5 className="text-dark">{tile.title}</h5>
                <p className="text-gray mb-0">{tile.text}</p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </>
  );
}
